<div mat-dialog-title>
  <h1>My Profile</h1>
  <div>
    <p>Please complete your profile. Keeping this information up-to-date helps us continue to focus our development
      where it matters most for your services.</p>
  </div>
  <hr>
</div>

<div mat-dialog-content>
  <div class="profile-form">
    <form [formGroup]="managerProfileForm">

      <div class="form-row">
        <div class="form-col">
          <mat-form-field appearance="fill">
            <mat-label>What is your name?</mat-label>
            <input matInput  formControlName="name" id="name" placeholder="Name"
                [attr.placeholder]="!(name.invalid && (name.touched || name.dirty)) ? 'Enter your name' : null"
 [attr.aria-invalid]="name.invalid && (name.touched || name.dirty) ? 'true' : null"
    [attr.aria-describedby]="name.invalid && (name.touched || name.dirty) ? 'name-error' : null">
            <mat-error id="name-error" *ngIf="name.invalid && (name.touched || name.dirty)">

    <!-- Hidden for UI, read by screen reader -->
    <span class="sr-only">Error  </span>

    <!-- Visible text -->
    Name is required.
            </mat-error>
          </mat-form-field>
        </div>
      </div>

      <div>
        <button mat-raised-button color="primary" class="done" [disabled]="managerProfileForm.invalid"
          (click)="donePressed()">Done</button>
      </div>

    </form>
  </div>
</div>